// extracted by mini-css-extract-plugin
export var modal = "_ak-0";